//----------------------------关键词定位开始------------------------------------
var oldkeywrods = "";
var getNumber = 0;
import $ from "jquery";

//去掉所有的html标记
function delHtmlTag(str) {
  return str.replace(/<[^>]+>/gi, "");
}

//html转义
function htmlDecode(value) {
  return $("<div/>")
    .html(value)
    .text();
}

function Trims(str) {
  return str.replace(/(^\s*)|(\s*$)/g, "");
}
//关键词高亮
function highlightKeyword(node, pattern, colorType, index) {
  let exposeCount = 0;
  if (node.nodeType === 3) {
    node.data = delHtmlTag(node.data);
    node.data = htmlDecode(node.data);

    let matchResult = node.data.match(pattern);

    if (matchResult) {
      let highlightEl = document.createElement("em");
      highlightEl.dataset.highlight = colorType;
      highlightEl.dataset.highlightMatch = matchResult[0];
      highlightEl.dataset.highlightIndex = index;
      let matchNode = node.splitText(matchResult.index);
      matchNode.splitText(matchResult[0].length);
      let highlightTextNode = document.createTextNode(matchNode.data);

      highlightEl.appendChild(highlightTextNode);
      matchNode.parentNode.replaceChild(highlightEl, matchNode);
      getNumber = getNumber + 1;
      exposeCount++;
    }
  }
  // 具体条件自己加，这里是基础条件
  else if (
    node.nodeType === 1 &&
    !/script|style/.test(node.tagName.toLowerCase())
  ) {
    if (node.dataset.highlight === colorType) {
      if (index == null) {
        return;
      }
      if (node.dataset.highlightIndex === index.toString()) {
        return;
      }
    }
    let childNodes = node.childNodes;
    for (let i = 0; i < childNodes.length; i++) {
      highlightKeyword(childNodes[i], pattern, colorType, index);
    }
  }
  return exposeCount;
}
//违规词获取网页全部内容
function sendkeywordshtml(node, colorType) {
  let wordlist = "";
  if (node.nodeType === 3) {
    if (Trims(node.data) !== "") {
      node.data = delHtmlTag(node.data);
      node.data = htmlDecode(node.data);
      node.data = Trims(node.data);
      wordlist += node.data + ",$|";
    }
  }
  // 具体条件自己加，这里是基础条件
  else if (
    node.nodeType === 1 &&
    !/script|style/.test(node.tagName.toLowerCase())
  ) {
    if (node.dataset.highlight === colorType) {
      return;
    }
    let childNodes1 = node.childNodes;
    for (var i = 0; i < childNodes1.length; i++) {
      sendkeywordshtml(childNodes1[i]);
    }
  }
  return wordlist;
}
//关键词处理
function hanldeKeyword(keywords) {
  let wordMatchString = "";
  let words = [].concat(keywords);
  words.forEach(item => {
    let transformString = item;

    if (transformString.length > 1) {
      let keywordsnum = 1;
      let keywordsallexp = "";
      for (let i = 0; i < transformString.length; i++) {
        let key1 = transformString.substring(i, keywordsnum);
        key1 = key1.replace(/([.[*?+^$|()/]|\]|\\)/g, "\\$1");
        keywordsnum += 1;

        i > 0
          ? (keywordsallexp += "[\\S|\\s]{0,5}" + key1)
          : (keywordsallexp += key1);
      }
      wordMatchString += `|(${keywordsallexp})`;
    } else {
      wordMatchString += `|(${transformString})`;
    }
  });

  wordMatchString = wordMatchString.substring(1);
  // 用于再次高亮与关闭的关键字作为一个整体的匹配正则
  var wholePattern = new RegExp(`^${wordMatchString}$`, "i");
  // 用于第一次高亮的关键字匹配正则
  // var pattern = new RegExp(wordMatchString, "i");
  return [wordMatchString, wholePattern];
}
//关闭高亮函数
function closeHighlight(pattern, colorType) {
  let highlightNodeList = document.querySelectorAll(
    "[data-highlight=" + colorType + "]"
  );
  for (let n = 0; n < highlightNodeList.length; n++) {
    if (pattern.test(highlightNodeList[n].dataset.highlightMatch)) {
      let parentNode = highlightNodeList[n].parentNode;
      let childNodes = highlightNodeList[n].childNodes;
      let childNodesLen = childNodes.length;
      let nextSibling = highlightNodeList[n].nextSibling;
      for (var k = 0; k < childNodesLen; k++) {
        parentNode.insertBefore(childNodes[0], nextSibling);
      }
      let flagNode = document.createTextNode("");
      parentNode.replaceChild(flagNode, highlightNodeList[n]);
      parentNode.normalize();
    }
  }
}
//关闭所有高亮函数
function closeAllHighlight() {
  let highlightNodeList = document.querySelectorAll("[data-highlight]");
  for (let n = 0; n < highlightNodeList.length; n++) {
    let parentNode = highlightNodeList[n].parentNode;
    let childNodes = highlightNodeList[n].childNodes;
    let childNodesLen = childNodes.length;
    let nextSibling = highlightNodeList[n].nextSibling;
    for (let k = 0; k < childNodesLen; k++) {
      parentNode.insertBefore(childNodes[0], nextSibling);
    }
    let flagNode = document.createTextNode("");
    parentNode.replaceChild(flagNode, highlightNodeList[n]);
    parentNode.normalize();
  }
}
//匹配高亮违规词hanldeKeyword
function findkeywords(keywords, colorType) {
  if (oldkeywrods !== "") {
    let oldpatterns = hanldeKeyword(oldkeywrods);
    closeHighlight(oldpatterns[1], colorType);
  }

  let patterns = hanldeKeyword(keywords);
  oldkeywrods = keywords;
  let bodyChildren = document.getElementsByClassName("mce-content-body")[0]
    .childNodes;
  for (let i = 0; i < bodyChildren.length; i++) {
    highlightKeyword(bodyChildren[i], patterns[0], colorType);
  }

  let _em = $("[data-highlight='" + colorType + "']");

  if (_em.length > 0) {
    for (let emnum = 0; emnum < _em.length; emnum++) {
      var _top = _em.eq(emnum).offset().top;
      $("html,body").animate(
        {
          scrollTop: _top - 280
        },
        1
      );
      break;
    }
  }
}

function findkeywords2(keywords, colorType, number) {
  if (oldkeywrods !== "") {
    let oldpatterns = hanldeKeyword(oldkeywrods);
    closeHighlight(oldpatterns[1], colorType);
  }

  let patterns = hanldeKeyword(keywords);
  oldkeywrods = keywords;
  let bodyChildren = document.getElementsByClassName("mce-content-body")[0]
    .childNodes;
  for (let i = 0; i < bodyChildren.length; i++) {
    if (getNumber > 0) {
      getNumber = 0;
      break;
    }
    if (i >= number) {
      highlightKeyword(bodyChildren[i], patterns[0], colorType);
    }
  }

  let _em = $("[data-highlight='" + colorType + "']");

  if (_em.length > 0) {
    for (let emnum = 0; emnum < _em.length; emnum++) {
      var _top = _em.eq(emnum).offset().top;
      $("html,body").animate(
        {
          scrollTop: _top - 280
        },
        1
      );
      break;
    }
  }
}
function repalceKeywords(keywords, colorType, number) {
  if (oldkeywrods !== "") {
    let oldpatterns = hanldeKeyword(oldkeywrods);
    closeHighlight(oldpatterns[1], colorType);
  }

  let patterns = hanldeKeyword(keywords);
  oldkeywrods = keywords;
  let bodyChildren = document.getElementsByClassName("mce-content-body")[0]
    .childNodes;
  for (let i = 0; i < bodyChildren.length; i++) {
    if (getNumber > 0) {
      getNumber = 0;
      break;
    }
    if (i >= number) {
      highlightKeyword(bodyChildren[i], patterns[0], colorType);
    }
  }

  let _em = $("[data-highlight='" + colorType + "']");

  if (_em.length > 0) {
    for (let emnum = 0; emnum < _em.length; emnum++) {
      var _top = _em.eq(emnum).offset().top;
      $("html,body").animate(
        {
          scrollTop: _top - 280
        },
        1
      );
      break;
    }
  }
}

export default {
  findkeywords,
  findkeywords2,
  sendkeywordshtml,
  closeAllHighlight,
  repalceKeywords
};

//----------------------------关键词定位结束-----------------------------------
